// initial state
import { Auth } from 'aws-amplify'

const state = {
  user: null,
  authState: 'unauthenticated',
  authViewState: 'signIn',
  authData: {},
  userEmail: '',
  userToken: {}
}

function initialState () {
  return {
    authState: 'unauthenticated',
    authViewState: 'signIn',
    authData: {},
    userEmail: '',
    userToken: {}
  }
}

// getters
const getters = {
}

// actions
const actions = {
  setAuthUser ({ commit, state }, payLoad) {
    commit('setUser', payLoad)
    commit('setUserEmail', payLoad.username)
  },
  setAuthState ({ commit, state }, payLoad) {
    commit('setAuthState', payLoad)
  },
  setAuthViewState ({ commit, state }, payLoad) {
    commit('setAuthViewState', payLoad)
  },
  setAuthData ({ commit, state }, payLoad) {
    commit('setAuthData', payLoad)
  },
  setUserEmail ({ commit, state }, payLoad) {
    commit('setUserEmail', payLoad)
  },
  setUserToken ({ commit, state }, payLoad) {
    return new Promise((resolve, reject) => {
      let data = payLoad
      if (!payLoad) {
        data = state.authState
      }
      Auth.userSession(data).then((session) => {
        if (session && session.isValid()) {
          commit('setUserToken', session.getIdToken().getJwtToken())
          resolve()
        }
      })
    })
  },
  resetAuthSate ({ commit, state }) {
    commit('reset')
  }
}
// mutations
const mutations = {
  setUser (state, user) {
    state.user = user
  },
  setAuthState (state, payLoad) {
    state.authState = payLoad
  },
  setAuthViewState (state, payLoad) {
    state.authViewState = payLoad
  },
  setAuthData (state, payLoad) {
    state.authData = payLoad
  },
  setUserEmail (state, payLoad) {
    state.userEmail = payLoad
  },
  setUserToken (state, payLoad) {
    state.userToken = payLoad
  },
  reset (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
